<script setup lang="ts">

import { ref } from 'vue';
import { useRoute } from 'vue-router';

import { computed } from '#imports';

const isShareOpen = ref(false);

const copyLinkText = ref<HTMLElement | null>(null);

const route = useRoute();

function copyLink() {
    const url = import.meta.env.VITE_DOMEN_URL + route.path;

    navigator.clipboard.writeText(url).then(() => {
        if (!copyLinkText.value) return;

        copyLinkText.value.textContent = 'Copied!';

        setTimeout(
            () => {
                if (copyLinkText.value) {
                    copyLinkText.value.textContent = 'Copy link';
                }
            },

            2000
        );
    });
}

const hrefShareToX = computed(() => encodeURIComponent(import.meta.env.VITE_DOMEN_URL + route.path));

const runtimeConfig = useRuntimeConfig();

</script>

<template>
  <Popover :is-open="isShareOpen"
           @update:is-open="(value: boolean) => (isShareOpen = value)"
  >
    <template #toggle>
      <button type="button"
              aria-label="share"
              class="display-flex align-items-center justify-center title-link btn-share cursor-pointer"
              @click="isShareOpen = !isShareOpen"
      >
        <IconMain :size="25"
                  icon="share"
        />
      </button>
    </template>
    <template #content>
      <div class="share-block display-flex flex-column align-items-start gap-8 with-shadow">
        <button type="button"
                aria-label="copy link"
                class="display-flex align-items-center gap-12 copy-url cursor-pointer h40"
                @click="copyLink"
        >
          <span class="display-flex align-items-center justify-center svg-block">
            <IconMain icon="copy"
                      :size="16"
            />
          </span>
          <span ref="copyLinkText"
                class="compact-400-accent"
          > Copy link </span>
        </button>
        <a :href="`https://twitter.com/intent/tweet?text=Check%20out%20this%20item%20in%20${runtimeConfig.public.name}&url=${hrefShareToX}`"
           aria-label="Catalog"
           target="_blank"
           class="display-flex align-items-center gap-12 link text-decor-none h40"
        >
          <div class="display-flex align-items-center justify-center svg-block">
            <IconMain icon="twitter"
                      :size="16"
            />
          </div>
          <p class="compact-400-accent text-no-wrap">
            Share on X
          </p>
        </a>
      </div>
    </template>
  </Popover>
</template>

<style lang="scss" scoped>
.text-no-wrap {
  text-wrap: nowrap;
}

.h40 {
  height: 40px;
}

.with-shadow {
  box-shadow: 0 4px 8px rgb(0 0 0 / 20%);
}

</style>

<style lang="scss">

.btn-share {
  transition: opacity 0.3s ease-in-out;
  color: var(--content-primary);

}

.title-link {
  min-width: var(--control-300-size-single, 28px);
  padding: 5px;
  border-radius: var(--control-500-radius, 2px);
  background: var(--bg-tertary);

  svg {
    width: 16px;
    height: 16px;
  }
}

.share-block {
  box-sizing: border-box;
  width: 144px;
  padding: 8px 16px;
  border-radius: var(--background-500-radius, 4px);
  background: var(--layer-floor-2);
}

.svg-block {
  width: 28px;
  height: 28px;
  background: var(--bg-tertary);
}

.copy-url {
  padding: 0;
  background: transparent;
  color: var(--content-primary);
}

</style>
